import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  DepositChipTone,
  type IDepositChipState,
} from './deposit-chip-display';

/**
 * The body of a deposit chip's tooltip.
 *
 * Split out of the chip so the copy can be rendered without hovering.
 * `pt-custom-tooltip` portals its content into the CDK overlay container,
 * which sits outside the chip's own DOM and holds one tooltip at a time —
 * so hovering can never show these side by side. Most of what the chip knows
 * is tooltip-only: the attention reason, the unresolved reason, the capture
 * strategy and the fallback all collapse to the same one or two markers on
 * the chip itself. Reviewing that copy means rendering it directly.
 *
 * A component rather than markup copied into a story, so what gets reviewed
 * is what ships.
 */
@Component({
  selector: 'pr-deposit-chip-tooltip',
  templateUrl: './deposit-chip-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
})
export class DepositChipTooltipComponent {
  readonly chip = input.required<IDepositChipState>();
  readonly depositChipTone = DepositChipTone;
}
